const updates = [
  {
    date: '07-28',
    title: '《契约婚姻有点甜》第48话更新',
    desc: '两人的关系出现了新的转折，男主的秘密即将被揭开...',
    tag: '韩漫更新',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-28',
    title: '《九霄仙途》第112话上线',
    desc: '主角突破元婴境界，远古遗迹的秘密逐渐浮出水面。',
    tag: '国漫更新',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    date: '07-28',
    title: '新作《深海迷踪》正式上线',
    desc: '科幻悬疑新作首发，深海探险与未知文明的碰撞，开局即高能。',
    tag: '新作首发',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '07-27',
    title: '《剑与魔法学院》第67话更新',
    desc: '学院大比进入决赛阶段，主角的隐藏实力终于展露。',
    tag: '日漫更新',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-27',
    title: '专题「恋爱漫画精选」上线',
    desc: '精选20部高甜恋爱漫画，从校园到职场，总有一部戳中你的少女心。',
    tag: '专题上新',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    date: '07-26',
    title: '《异世界美食家》第35话更新',
    desc: '新角色登场！一个来自东方的神秘厨师带来了全新的美食挑战。',
    tag: '韩漫更新',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-26',
    title: '系统升级：阅读器新增横屏模式',
    desc: '蛙漫阅读器全面升级，支持横屏双页阅读，大屏设备体验更佳。',
    tag: '功能更新',
    tagColor: 'bg-primary-100 text-primary-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
            更新动态
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
            最新更新与动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-[600px] mx-auto">
            漫画更新、新作上线、功能升级，第一时间掌握蛙漫最新动态
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className={`flex items-start gap-4 md:gap-5 p-4 rounded-2xl transition-colors cursor-pointer hover:bg-background-50 ${
                i < updates.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div className="shrink-0 w-14 md:w-16 text-center">
                <div className="text-xs font-bold text-primary-600 bg-primary-50 rounded-lg py-1">
                  {item.date}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <h3 className="text-sm font-bold text-foreground-900 font-heading">
                    {item.title}
                  </h3>
                  <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}